module.exports = "https://static.wmbcdn.com/uniweb/images/0161ab1296a1684b55b92392545f0834.svg";